// Helper function to add content to a worksheet
export function addWorksheetContent(worksheet, title, columns, rows) {
  // Add Worksheet Header
  addWorksheetHeader(worksheet, title)

  // Add Table to Worksheet
  addTableToWorksheet(worksheet, columns, rows)

  // Style Worksheet
  styleWorksheet(worksheet, columns, rows)
}

// Helper function to add a header to a worksheet
function addWorksheetHeader(worksheet, title) {
  worksheet.mergeCells('A2:M2')

  const headerCell = worksheet.getCell('A2')

  headerCell.font = {
    name: 'Times New Roman',
    family: 4,
    size: 20,
    underline: true,
    bold: true
  }
  headerCell.alignment = { vertical: 'middle', horizontal: 'center' }
  headerCell.width = 5
  headerCell.height = 40
  headerCell.value = title
}

// Helper function to add a table to a worksheet
function addTableToWorksheet(worksheet, columns, rows) {
  worksheet.addTable({
    name: 'Table',
    ref: 'A5',
    headerRow: true,
    style: {
      theme: 'TableStyleMedium9',
      showRowStripes: true
    },
    columns: columns,
    rows: rows
  })
}

// Helper function to style a worksheet
function styleWorksheet(worksheet, columns, rows) {
  worksheet.views = [
    { state: 'frozen', xSplit: 0, ySplit: 5, topLeftCell: 'A6' }
  ]

  for (let i = 0; i < columns.length; i++) {
    worksheet.getColumn(i + 1).width = 20
  }

  worksheet.getRow(5).height = 30

  const tableRows = worksheet.getRows(6, 6 + rows.length)

  for (let row of tableRows) {
    row.height = 30
  }
}
